import { Radio } from "antd";

const RadioGroup = ({
  label,
  icon,
  options = [],
  errors,
  touched,
  isHorizental = false,
  column,
  ...rest
}) => {
  return (
    <div className={`radio-group ${isHorizental && "group--horizental"}`}>
      <div className="radio-group__content">
        <div className="radio-group__content--icon" hidden={!icon}>
          {icon}
        </div>
        <label className="radio-group__content--label">{label}</label>
      </div>
      <div className="radio-group__radio">
        <Radio.Group
          className={`radio-group__radio--radio ${column && "flex--column"}`}
          options={options}
          optionType="button"
          buttonStyle="solid"
          {...rest}
        />
        {touched && (
          <small className={"radio-group__radio--error"}>{errors}</small>
        )}
      </div>
    </div>
  );
};

export default RadioGroup;
